export default __webpack_public_path__ + "static/media/profilePic1.eed81ca2.jpg";